function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  id: "a",
  d: "M42.245 28.697c.525-.395 1.225-.22 1.564.392.339.61.188 1.426-.337 1.82l-3.761 2.827-4.155-2.793c-.542-.363-.727-1.169-.414-1.798.312-.63 1.004-.846 1.545-.482l2.958 1.988 2.6-1.954zm-1.255 2.789a1.312 1.312 0 1 1-2.625 0 7.875 7.875 0 1 0-7.875 7.875 1.313 1.313 0 0 1 0 2.625c-5.8 0-10.5-4.701-10.5-10.5s4.7-10.5 10.5-10.5c5.799 0 10.5 4.701 10.5 10.5zm-16.5-19.5v-4.5h3v7a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-7h3v4.5h6zm-12 15a1.5 1.5 0 1 1 0-3h3a1.5 1.5 0 0 1 0 3h-3zm25.475-2.953h-3V10.5a1.5 1.5 0 0 0-1.5-1.5H9.5A1.5 1.5 0 0 0 8 10.5v18.017a1.5 1.5 0 0 0 1.5 1.5h11.99v3H9.5a4.5 4.5 0 0 1-4.5-4.5V10.5A4.5 4.5 0 0 1 9.5 6h23.965a4.5 4.5 0 0 1 4.5 4.5v13.533z"
});

var SvgDeliveryUpdate = function SvgDeliveryUpdate(props) {
  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref);
};

export default SvgDeliveryUpdate;


//////////////////
// WEBPACK FOOTER
// ./src/icons/shipment-status/delivery-update.svg
// module id = 188
// module chunks = 0 1